import { IconLabel } from '@mxa-argos/components/custom/icon-label';
import { formatPhoneNumber } from '@mxa-argos/lib/phone-formatter';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { Phone, User } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function PersonSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={User}
      primary={result.primary}
      secondary={
        result.secondary && (
          <span className="font-mono text-sm text-muted-foreground">{result.secondary}</span>
        )
      }
      tertiary={result.tertiary}
      quaternary={
        result.quaternary && <IconLabel icon={Phone} value={formatPhoneNumber(result.quaternary)} />
      }
    />
  );
}
